<template>
<div class="chapter">
<div class="inner_page">
<h2><a id="page_xi"></a>ILLUSTRATIONS</h2>
<p class="paraindent1">The opening lines of the Grasmere Journals, 26</p>
<p class="paraindent">The back cover of the first notebook of the Grasmere Journals, 31</p>
<p class="paraindent">Racedown, drawing by S. L. May, 78</p>
<p class="paraindent">Scullery maid, drawing by John Harden, 135</p>
<p class="paraindent">Daffodil (<em class="italic">Narcissus pseudo-narcissus</em> L.), by Walter Hood Fitch, 177</p>
<p class="paraindent">Blotting paper in the Grasmere Journals, 203</p>
<p class="paraindent">The Grasmere Journals, May 29, 1802, 209</p>
<p class="paraindent">Swallow, by Thomas Bewick, 217</p>
<p class="paraindent">Entry for October 4, 1802, in the Grasmere Journals, 234</p>
<p class="paraindent">The road to Brompton from Gallow Hill, sketch in the Grasmere Journals, 240</p>
<p class="paraindent">Final page of the Grasmere Journals, 260</p>
<p class="paraindent">Rydal Mount, drawing by Dora Wordsworth, 269</p>
<p class="paraindent">Dorothy in a wheelchair, drawing by John Harden, 1842, 275</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// frontmatter002.vue?fc7d4cac